import React, { useContext } from "react";
import style from "./index.module.scss";
import { Button, Table, Tooltip } from "antd";
import { ColumnProps, SorterResult, SortOrder } from "antd/lib/table/interface";
import StuTableColumn from "components/CourseComponents/StuTableColumn";
import { CourseContext } from "../../../../Store";
import { useHistory } from "react-router-dom";
import { ListsItem } from "service/question";
import moment from "moment";
import { exerciseInfoAtom, sorterAtom } from "service/stores/Question/Students";
import { useAtom } from "jotai";
import { useAtomValue } from "jotai";
import { isTrue } from "../../../../../../service/service";

interface StudentsTableProps {
    data: ListsItem[];
    questionnaireId: number;
}

export default function StudentsTable({
    data,
    questionnaireId
}: StudentsTableProps) {
    const { basename } = useContext(CourseContext);
    const history = useHistory();
    const sortDirections: SortOrder[] = ["descend", "ascend"];
    const [sorter, setSorter] = useAtom(sorterAtom);
    const exerciseInfo = useAtomValue(exerciseInfoAtom);

    function getSortOrder(field: string) {
        return sorter.field === field ? sorter.order : false;
    }

    const columns: ColumnProps<ListsItem>[] = [
        {
            title: "序号",
            dataIndex: "index",
            align: "center",
            render: (text, item, index) => index + 1
        },
        {
            title: "班级",
            dataIndex: "className",
            align: "center",
            render: text => (
                <div className={style.column}>
                    <Tooltip placement="topLeft" title={text}>
                        {text}
                    </Tooltip>
                </div>
            )
        },
        {
            title: "学生信息",
            dataIndex: "studentNo",
            align: "left",
            render: (val, item) => (
                <StuTableColumn name={item.name} stuNo={val} />
            )
        },
        {
            title: "参与状态",
            dataIndex: "joinStatus",
            align: "center",
            render: text => <div>{text === "0" ? "未参与" : "已参与"}</div>
        },
        {
            title: "提交时间",
            dataIndex: "submitTime",
            align: "center",
            sortDirections: sortDirections,
            render: text => (
                <div>{text ? moment(text).format("MM-DD HH:mm") : "--"}</div>
            ),
            sorter: true,
            sortOrder: getSortOrder("submitTime")
        },
        {
            title: "操作",
            align: "center",
            render: (_, item) => {
                return (
                    <div className={style.operation}>
                        {!isTrue(exerciseInfo.anonymityFlag) && (
                            <Button
                                type="link"
                                onClick={() => gotoReview(item.studentNo)}>
                                查看提交内容
                            </Button>
                        )}
                    </div>
                );
            }
        }
    ];

    function gotoReview(studentNo: string) {
        history.push(
            `${basename}/question/students/${questionnaireId}/review/${studentNo}`
        );
    }

    function onChange(
        pagination: unknown,
        filters: unknown,
        sorter: SorterResult<any>
    ) {
        setSorter(sorter);
    }

    return (
        <div className={style.root}>
            <Table
                columns={columns}
                dataSource={data}
                rowKey="studentNo"
                pagination={false}
                onChange={onChange}
            />
        </div>
    );
}
